export default function SmallInfo({ title, children, ...props }) {
    return (
        <div>
            <h2 className="uppercase text-xxs font-sans font-black text-green-100 mb-1">{title}</h2>
            <div className="text-xs" {...props}>{children}</div>
        </div>
    )
}